import PlayableAudioCard from './PlayableAudioCard';

export default PlayableAudioCard;
